import Highway from '@dogstudio/highway'
import modular from 'modujs'
import { classesInjection } from './utils/transitions'
import FadeTransition from './modules/FadeTransition'
import Scroller from './modules/Scroller'
import * as modules from './modules'

const Modular = modular
const app = new Modular({
  modules,
})

class DefaultRenderer extends Highway.Renderer {
  onEnterCompleted() {
    app.init(app)
    return this
  }
}

const init = () => {
  classesInjection()
  new Scroller()

  const H = new Highway.Core({
    renderers: {
      default: DefaultRenderer,
    },
    transitions: {
      default: FadeTransition,
    },
  })

  H.on('NAVIGATE_IN', ({ trigger }) => {
    window.lenis.start()

    if (trigger !== 'popstate') {
      window.lenis.scrollTo(0, {
        lock: true,
        immediate: true,
      })
    }
  })

  window.H = H
}

document.addEventListener('DOMContentLoaded', init)
